// NOTE: this is a naive implementation and only works for flat objects with primitive values
export default function isFlatObjectEqual(object1 = {}, object2 = {}) {
	return (
		Object.keys(object1).length === Object.keys(object2).length &&
		Object.entries(object1).every(([key, value]) => object2[key] === value)
	)
}
